import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { localStorageKeys } from '../../constants/local.storage.keys';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private router: Router, private apiService: ApiService) {}

  public static get authorized() {
    return !!localStorage.getItem(localStorageKeys.authToken);
  }

  get currentUser$(): Observable<any> {
    return of(this.getCurrentUser());
  }

  login(command: { userName: string; password: string }): Observable<string> {
    return this.apiService
      .post('auth/login', command)
      .pipe(tap((token) => this.apiService.setAuthorizationHeader(token)));
  }

  logout(): void {
    this.apiService.clearAuthorizationHeader();
  }

  getCurrentUser(): any {
    const user = localStorage.getItem(localStorageKeys.authToken);
    return user ? JSON.parse(user) : null;
  }
}

export class TokenInfo {
  public hubName: string;
  public userName: string;
  public isAdministrator: boolean;
  public role: undefined | 'ig-admin' | 'ig-event-puller';
  public status: string;
}
